import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import CouponCommon from 'common/components/entities/Coupon'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import { voidFunc } from 'common/utils/void-function'
import React from 'react'

export default function Coupon({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CouponInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CouponCommon
        {...entity}
        isChecking={false}
        onCodeChange={voidFunc}
        onCheck={voidFunc}
        couponCode=""
      />
    </BaseEntityNew>
  )
}
